import DeleteIcon from '@mui/icons-material/Delete';
import { useState } from 'react';
import { Button, Tooltip } from '@mui/material';
import { AlertDialog } from '../../../components/AlertDialog';

type DeleteUserProps = {
  onClick: () => void;
  disabled?: boolean;
  showText?: boolean;
};

export const DeleteAdminDialog = ({
  onClick,
  disabled,
  showText = false,
}: DeleteUserProps) => {
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleDelete = () => {
    onClick();
    handleClose();
  };

  return (
    <>
      {showText ? (
        <Button
          variant="warningSecondary"
          startIcon={<DeleteIcon />}
          onClick={handleClickOpen}
          disabled={disabled}
          size="small"
        >
          Delete admin
        </Button>
      ) : (
        <Tooltip title="Delete admin">
          <span>
            <Button
              variant="warningLink"
              aria-label="delete admin"
              onClick={handleClickOpen}
              size="small"
              disabled={disabled}
              sx={{
                minWidth: 'unset',
                width: '32px',
                height: '32px',
                borderRadius: '50%',
              }}
            >
              <DeleteIcon />
            </Button>
          </span>
        </Tooltip>
      )}
      <AlertDialog
        variant="alert"
        open={open}
        onClose={handleClose}
        title="Are you sure you want to delete this admin?"
        description="This admin will be permanently deleted and cannot be undone."
        actions={{
          cancel: {
            label: 'Cancel',
            onClick: handleClose,
          },
          confirm: {
            label: 'Delete',
            onClick: handleDelete,
          },
        }}
      />
    </>
  );
};

export default DeleteAdminDialog;
